'use strict';

(function (moment) {
	function Controller($stateParams, pmtLoggerService, $i18next) {
		let $ctrl = this;

		function initializeCounts() {
			$ctrl.newHours = $ctrl.data.new.length;
			$ctrl.unchangedHours = $ctrl.data.unchanged.length;
			$ctrl.deletedHours = $ctrl.data.deleted.length;
			$ctrl.editedHours = $ctrl.data.edited.length;
		}

		function sortDataByStoreId() {
			const sortByStoreId = (a, b) => {
				const storeIdA = a.storeId.toUpperCase();
				const storeIdB = b.storeId.toUpperCase();
				return storeIdA.localeCompare(storeIdB);
			};

			$ctrl.new = $ctrl.data.new.sort(sortByStoreId);
			$ctrl.unchanged = $ctrl.data.unchanged.sort(sortByStoreId);
			$ctrl.deleted = $ctrl.data.deleted.sort(sortByStoreId);
			$ctrl.edited = $ctrl.data.edited.sort(sortByStoreId);
		}

		function setupFilters() {
			$ctrl.filters = {
				all: {
					title: $i18next.t('general.all'),
					icon: 'fa-solid fa-folder-open',
					count: $ctrl.newHours + $ctrl.editedHours + $ctrl.deletedHours + $ctrl.editedHours
				}
			};

			if ($ctrl.data.inputValidationResult.length > 0) {
				$ctrl.filters.errors = {
					title: $i18next.t('general.error', { count: $ctrl.data.inputValidationResult.length }),
					icon: 'fa-solid fa-exclamation-circle',
					count: $ctrl.data.inputValidationResult.length
				};
			}

			['new', 'deleted', 'unchanged'].forEach(type => {
				if ($ctrl[`${type}Hours`] > 0) {
					$ctrl.filters[type] = {
						title: $i18next.t(`listings.special_open_hours.${type}_special_open_hours`),
						icon: `fa-solid fa-${type === 'new' ? 'star' : type === 'deleted' ? 'trash' : 'check'}`,
						count: $ctrl[`${type}Hours`]
					};
				}
			});

			if ($ctrl.editedHours > 0) {
				$ctrl.filters.edited = {
					title: $i18next.t('listings.special_open_hours.edited_special_open_hours'),
					icon: 'fa-solid fa-code-branch',
					count: $ctrl.editedHours
				};
			}
		}

		$ctrl.$onInit = function () {
			initializeCounts();
			sortDataByStoreId();
			setupFilters();
			$ctrl.activeFilter = 'all';
		};

		$ctrl.locationTitleByStoreId = function (storeId) {
			const matchedPlace = $ctrl.places.find(place => place.storeId === storeId);
			let placeName = matchedPlace
				? matchedPlace.name
				: $i18next.t('listings.special_open_hours.unnamed_location');
			if (matchedPlace && matchedPlace.locationDescriptor) {
				placeName += ` (${matchedPlace.locationDescriptor})`;
			}
			return placeName;
		};

		$ctrl.formatErrorMessage = function (error) {
			try {
				if (error.startsWith('overlapping not allowed!')) {
					const dateMatch = /\"start\":\"(.+?)\",\"/.exec(error);
					const date = moment(new Date(dateMatch[1])).format('YYYY-MM-DD');
					let indexes = error
						.match(/"index":(\d+)/g)
						.map(s => s.replace('"index":', ''))
						.join(', ');
					return $i18next.t('listings.special_open_hours.overlapping_rows', { indexes, date });
				}
				return error;
			} catch (err) {
				const e = new Error(
					JSON.stringify({ siteName: $stateParams.site, error: err, errorToFormat: error })
				);
				pmtLoggerService.exceptionHandler(e, 'pmtSpecialHoursImportStatus.formatErrorMessage');
				return error;
			}
		};

		$ctrl.cancelImport = function () {
			$ctrl.cancel();
		};

		$ctrl.confirmImport = function () {
			$ctrl.confirm();
		};
	}

	Controller.$inject = ['$stateParams', 'pmtLoggerService', '$i18next'];

	angular.module('pmtPlacesApp.directives').component('pmtSpecialHoursImportStatus', {
		templateUrl: 'components/specialhours/pmtSpecialHoursImportStatus.html',
		controller: Controller,
		bindings: {
			data: '<',
			places: '<',
			cancel: '&',
			confirm: '&'
		}
	});
})(window.moment);
